import { Link, useLocation, useNavigate } from "react-router-dom";
import { TitleContainer, Wrapper } from "../../style";
import ColumnContainer from "../../../common/ColumnContainer";
import RowContainer from "../../../common/RowContainer";
import { Card, Divider, Typography } from "@mui/material";
import "./CreditsStyle.less";
import { DashboardButton } from "../../../common/DashboardButton";
import { userDashboardRoute } from "../../../../utils/routes/Routes";
import PayPalCheckoutButtons from "../payPal/PayPalCheckoutButtons";
import { useSelector } from "react-redux";
import { selectOrder } from "../../../../redux/features/orders/orderSlice";
import { FormattedMessage } from "react-intl";

const BuyCreditsCheckoutPage = () => {
  const navigate = useNavigate();

  const newOrder = useSelector(selectOrder);

  const tax = newOrder?.orderAmount?.toFixed(2) * 0.22;

  const handleGoBackToOrder = () => {
    navigate(userDashboardRoute.buyCredits);
  };

  return (
    <Wrapper className="buy-credits-page checkout">
      <ColumnContainer start style={{ height: "100vh" }}>
        <ColumnContainer halfGap sx={{ gap: "40px" }}>
          <RowContainer align="center">
            <TitleContainer
              style={{
                backgroundColor: "var(--bkg-light)",
              }}
            >
              <Typography
                variant="h4"
                component="h4"
                sx={{ color: "#000 !important" }}
              >
                <FormattedMessage id="order.new" />
              </Typography>
            </TitleContainer>
            <DashboardButton
              type="filled"
              sx={{ width: "50%" }}
              onClick={handleGoBackToOrder}
            >
              <FormattedMessage id="button.modifyOrder" />
            </DashboardButton>
          </RowContainer>
        </ColumnContainer>
        <ColumnContainer>
          <RowContainer start>
            <Card className="checkout-card final-step">
              <ColumnContainer>
                <ColumnContainer>
                  <RowContainer>
                    <Typography variant="body2" component="p" fontSize={"22px"}>
                      {newOrder?.credits} <FormattedMessage id="credits" />
                    </Typography>
                    <RowContainer align="center" end>
                      <Typography
                        variant="body1"
                        component="p"
                        fontSize={"22px"}
                      >
                        {newOrder?.orderAmount?.toFixed(2)} €
                      </Typography>
                    </RowContainer>
                  </RowContainer>
                </ColumnContainer>
                <ColumnContainer>
                  <RowContainer>
                    <Typography
                      variant="body2"
                      component="p"
                      fontSize={"18px"}
                      color={"var(--text-secondary)"}
                    >
                      <FormattedMessage id="order.vat" /> 22%
                    </Typography>
                    <RowContainer align="center" end>
                      <Typography
                        variant="body1"
                        component="p"
                        fontSize={"18px"}
                        color={"var(--text-secondary)"}
                      >
                        {tax?.toFixed(2)} €
                      </Typography>
                    </RowContainer>
                  </RowContainer>
                </ColumnContainer>
                <Divider sx={{ borderColor: "var(--text-primary)" }} />
                <ColumnContainer>
                  <RowContainer>
                    <Typography
                      variant="body2"
                      component="p"
                      fontSize={"22px"}
                      fontWeight={800}
                    >
                      <FormattedMessage id="order.total" />
                    </Typography>

                    <RowContainer align="center" end>
                      <Typography
                        variant="body1"
                        component="p"
                        fontSize={"22px"}
                        fontWeight={800}
                      >
                        {newOrder?.orderAmount?.toFixed(2)} €
                      </Typography>
                    </RowContainer>
                  </RowContainer>
                </ColumnContainer>
              </ColumnContainer>
            </Card>
          </RowContainer>
          <RowContainer start className="paypal-btns-external-container">
            <PayPalCheckoutButtons />
          </RowContainer>
        </ColumnContainer>
      </ColumnContainer>
    </Wrapper>
  );
};

export default BuyCreditsCheckoutPage;
